import styled, { css } from 'styled-components/macro'

export const AnimationContainer = styled.div`
  position: absolute;
  overflow: hidden;
  aspect-ratio: 16/9;

  @media (max-width: 1024px) {
    aspect-ratio: 256/267;
  }
  @media (max-width: 520px) {
    aspect-ratio: 115/157;
  }

  min-height: 100%;
  min-width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;

  img {
    position: absolute;
  }

  @keyframes hand1ani {
    0% {
      transform: translateY(-5%) rotate(0deg);
    }
    25% {
      transform: translateY(-3%) rotate(6deg);
    }
    50% {
      transform: translateY(-5%) rotate(12deg);
    }
    75% {
      transform: translateY(-3%) rotate(6deg);
    }
    100% {
      transform: translateY(-5%) rotate(0deg);
    }
  }
  @keyframes hand2ani {
    0% {
      transform: translateY(0%) rotate(0deg);
    }
    25% {
      transform: translateY(2%) rotate(-12deg);
    }
    50% {
      transform: translateY(0%) rotate(-24deg);
    }
    75% {
      transform: translateY(2%) rotate(-12deg);
    }
    100% {
      transform: translateY(0%) rotate(0deg);
    }
  }
  @keyframes personAniL {
    0% {
      left: -40%;
    }
    100% {
      left: 0%;
    }
  }
  @keyframes personAniM {
    0% {
      left: -70%;
    }
    100% {
      left: 0%;
    }
  }
  @keyframes personAniS {
    0% {
      left: -100%;
    }
    100% {
      left: 0%;
    }
  }
  @keyframes figureAni {
    0% {
      top: -2%;
    }
    25% {
      top: 0%;
    }
    50% {
      top: -2%;
    }
    75% {
      top: 0%;
    }
    100% {
      top: -2%;
    }
  }
`
export const Background = styled.img`
  width: 100%;
  bottom: 0;
`
export const Person = styled.div<{ $isPageVisible: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -40%;
  @media (max-width: 1024px) {
    left: -60%;
  }
  /*transition: left 2s;
    transition-timing-function: ease-in-out;*/
  ${(props) =>
    props.$isPageVisible
      ? css`
          animation: personAniL 1s ease-out forwards;
          animation-iteration-count: 1;
          @media (max-width: 1024px) {
            animation: personAniM 1s ease-out forwards;
          }
          @media (max-width: 520px) {
            animation: personAniS 1s ease-out forwards;
          }
        `
      : ''}
`
export const Figure = styled.img<{ $isPageVisible: boolean }>`
  top: -2%;
  left: 23%;
  width: 70%;
  @media (max-width: 1024px) {
    left: 0;
    width: 100%;
  }
  @media (max-width: 1024px) {
    left: 0;
    width: 104%;
  }
  ${(props) =>
    props.$isPageVisible
      ? css`
          animation: figureAniL 1s ease-in-out forwards;
          animation-iteration-count: 1;
        `
      : ''}
`
export const Hand1 = styled.img<{ $isPageVisible: boolean }>`
  top: -5%;
  width: 14%;
  left: 80%;
  transform-origin: 0% 0%;
  @media (max-width: 1024px) {
    width: 28%;
    left: 80%;
  }
  @media (max-width: 520px) {
    width: 32%;
    left: 88%;
  }
  ${(props) =>
    props.$isPageVisible
      ? css`
          animation: 1s hand1ani linear forwards;
          animation-iteration-count: 1;
        `
      : ''}
`
export const Hand2 = styled.img<{ $isPageVisible: boolean }>`
  top: -5%;
  width: 76%;
  left: 5.5%;
  transform-origin: 80% -5%;
  @media (max-width: 1024px) {
    width: 95%;
    left: -6.5%;
  }
  @media (max-width: 520px) {
    width: 100%;
    left: 0%;
  }
  ${(props) =>
    props.$isPageVisible
      ? css`
          animation: 1s hand2ani linear forwards;
          animation-iteration-count: 1;
        `
      : ''}
`
